const isNumeric = (value: string): boolean => {
  return [...value].every(char => {
    return !isNaN(char);
  });
};

export const isValidPhoneNumber = (value: string): boolean => {
  if (!value) {
    return true;
  }
  if (value.startsWith("+")) {
    value = value.substring(1);
  }
  if (!isNumeric(value)) {
    return false;
  }
  return true;
};

// Lowercases and strips diacritics, so that "lefevre" matches « Lefèvre » and "gouttiere" « Gouttières ».
export const normalizeString = (value: string): string =>
  value.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
